export enum LeadType {
  Individual = 1,
  Company = 2,
}

export enum LeadGenderType {
  Unknown = 0,
  Male = 1,
  Female = 2,
}
